/* global L */
angular.module('Itao.IndicatorMap').controller(
  'IndicatorMapController',
  function ($scope,
            $q,
            $timeout,
            $element,
            $http,
            DistrictStyling,
            mapConfig,
            DataLayerService,
            UtilityService,
            d3) {
    'use strict';

    // init directive scope variables
    $scope.config = {};
    $scope.numberOfScaleOptions = [1, 2, 3, 4, 5, 6];

    if ($scope.indicatorToShow && ($scope.indicatorToShow.defaultScale || $scope.selectedDataLayer.legend[$scope.indicatorToShow.uid])) {
      $scope.config.numberOfScales = $scope.indicatorToShow.length;
    } else {
      $scope.config.numberOfScales = $scope.config.numberOfScales || mapConfig.numberOfScales;
    }

    $scope.config.districtOpacity = $scope.config.districtOpacity || mapConfig.styling.default.fillOpacity;
    $scope.config.displayValues = $scope.config.displayValues || false;
    $scope.config.indicatorToShow = $scope.config.indicatorToShow || '';
    $scope.config.indicatorToShowInverted = $scope.config.indicatorToShowInverted === undefined ? false : $scope.config.indicatorToShowInverted;
    $scope.config.selectedColorSet = $scope.config.selectedColorSet || '';
    $scope.config.labelAlignment = $scope.config.labelAlignment || 'auto';
    $scope.config.selectedClassMethod = $scope.config.selectedClassMethod || mapConfig.defaultSelectedClassMethod;
    $scope.config.optionStates = $scope.config.optionStates || angular.copy(mapConfig.defaultLabels);
    $scope.config.legendMode = $scope.config.legendMode || 'small';
    $scope.config.fullscreen = $scope.config.fullscreen || false;
    $scope.selectedColorSet = null;
    $scope.indicatorToShow = null;
    $scope.config.showCharts = $scope.config.showCharts === undefined ? true : $scope.config.showCharts;
    $scope.scaleMethod = 'width';

    var mouseOverFeatureKey = '';
    var districtSingleSelection = '';
    var districtInfo = '';
    var info;
    var germanNumberFormat = d3.hyperion.germanFormat.numberFormat;
    var numberFormat = germanNumberFormat(',.2f');
    var groupDistricts = jQuery('#groupDistricts');
    var featureGroups;

    /**
     * re-colors features after indicator-select or clears features when all indicators are deselected
     * @param {Indicator} indicator
     */
    var indicatorToShowWatcher = $scope.$watch('config.indicatorToShow', function (indicator) {
      if (indicator) {
        germanNumberFormat = d3.hyperion.germanFormat.numberFormat('.' + getDecimals() + 'f');
        var indicatorToShowPosition = $scope.selectedIndicators.map(function (d) {
          return d.key;
        }).indexOf(indicator);
        if (indicatorToShowPosition !== -1) {

          $scope.indicatorToShow = $scope.selectedIndicators[indicatorToShowPosition];
          if ($scope.indicatorToShow) {
            if ($scope.selectedDataLayer.legend && $scope.selectedDataLayer.legend[$scope.indicatorToShow.uid] != null && $scope.selectedDataLayer.legend[$scope.indicatorToShow.uid].map != null) {
              $scope.config.selectedColorSet = $scope.selectedDataLayer.legend[$scope.indicatorToShow.uid]['map'].colorSet;

            } else if ($scope.indicatorToShow.defaultColorSet) {
              $scope.config.selectedColorSet = $scope.indicatorToShow.defaultColorSet;
            }

            $scope.indicatorToShow.updateScales($scope.selectedDataLayer, $scope.indicatorToShow, $scope.selectedColorSet, $scope.config.selectedClassMethod, $scope.config.numberOfScales);
            // check if colors have to be inverted
            if ($scope.indicatorToShow.inverted !== $scope.config.indicatorToShowInverted) {
              $scope.indicatorToShow.invertScale();
            }
          }

          $scope.colorDistrictsBasedOnIndicatorScale();
        } else {
          $scope.indicatorToShow = null;
          clearFeatures();
        }
      } else {
        $scope.indicatorToShow = null;
        if ($scope.geojson) {
          clearFeatures();
        }
      }
      $scope.changeTooltip();
    });

    var invertedWatcher = $scope.$watch('config.indicatorToShowInverted', function (newValue) {
      // TODO: find better mechanism to change order of applied changes
      $timeout(function () { // invert after all other changes
        if ($scope.indicatorToShow && ($scope.indicatorToShow.inverted !== newValue)) {
          $scope.indicatorToShow.invertScale();
          $scope.colorDistrictsBasedOnIndicatorScale();
        }
      }, 10);
    });

    /**
     * Render Indicator-Charts
     */
    var selectedIndicatorsWatcher = $scope.$watchCollection('selectedIndicators', function (selectedIndicators) {
      if (angular.isArray(selectedIndicators) && selectedIndicators.length > 0) {
        if ($scope.config.indicatorToShow === ''
          || $scope.config.indicatorToShow == null
          || selectedIndicators.map(function (d) {
            return d.key;
          }).indexOf($scope.config.indicatorToShow) === -1) {
          // select first as default
          // $scope.config.indicatorToShow = selectedIndicators[0].key;
          for (var i = 0, len = $scope.selectedIndicators.length; i < len; i++) {
            if (selectedIndicators[i].hasShapeData) {
              $scope.config.indicatorToShow = $scope.selectedIndicators[i].key;
              break;
            }
          }
        }
      } else {
        $scope.config.indicatorToShow = '';
      }
      $scope.changeTooltip();
    });

    /**
     * reprintMap with colors
     */
    var selectedColorSetWatcher = $scope.$watch('config.selectedColorSet', function (selectedColorSet) {
      if (angular.isArray($scope.colorSets) && $scope.colorSets.length > 0) {
        var colorSetIndex = $scope.colorSets.map(function (d) {
          return d.uid;
        }).indexOf(+selectedColorSet);

        //default to first colorSet
        if (colorSetIndex === -1) {
          colorSetIndex = 0;
        }
        $scope.numberOfScaleOptions = $scope.colorSets[colorSetIndex].colors.map(function (d, i) {
          return i + 1;
        });
        if ($scope.numberOfScaleOptions.indexOf($scope.config.numberOfScales) === -1) {
          $scope.config.numberOfScales = $scope.numberOfScaleOptions[$scope.numberOfScaleOptions.length - 1];
        }
        $scope.selectedColorSet = $scope.colorSets[colorSetIndex];
        if (!$scope.indicatorToShow) return;

        $scope.indicatorToShow.updateScales($scope.selectedDataLayer, $scope.indicatorToShow, $scope.selectedColorSet, $scope.config.selectedClassMethod, $scope.config.numberOfScales);
        $scope.colorDistrictsBasedOnIndicatorScale();
      }
    });

    var colorSetsWatcher = $scope.$watchCollection('colorSets', function (newSets) {
      if (angular.isArray(newSets) && newSets.length > 0) {
        //default first
        var colorSetIndex = newSets.map(function (d) {
          return d.uid;
        }).indexOf($scope.config.selectedColorSet);
        if (colorSetIndex === -1) {
          colorSetIndex = 0;
        }
        $scope.config.selectedColorSet = newSets[colorSetIndex].uid;
      }
    });

    var selectedDistrictsWatcher = $scope.$watchCollection('selectedDistricts', function () {
      $scope.colorDistrictsBasedOnIndicatorScale();
    });

    var selectedAlignmentWatcher = $scope.$watch('config.labelAlignment', function (selectedLabelAlignment) {
      $scope.changeTooltip();
    });

    /**
     * redraws the map after dataLayer-changes
     */
    var selectedDataLayerWatcher = $scope.$watch('selectedDataLayer', function (datalayer) {
      if (!angular.isDefined(datalayer)) return;
      if (angular.isDefined($scope.config.dataLayerToShow) && !angular.isDefined($scope.dataLayerToShow) && angular.isObject($scope.layers) && $scope.layers.hasOwnProperty($scope.config.dataLayerToShow)) {
        // set datalayer from config
        $scope.setDataLayerData($scope.layers[$scope.config.dataLayerToShow]);
      } else {
        // set new datalayer
        $scope.setDataLayerData(datalayer);
      }
    });

    /**
     * inform leaflet that te dimensions of the map changed
     * this leads to recalculating, which tiles have to be shown etc.
     */
    var dimensionWatcher = $scope.$watchGroup(['dimensionX', 'dimensionY'], function () {
      jQuery($element).find('.map').height(jQuery($element).closest('.grid-stack-item-content-map').height());
      $scope.map.invalidateSize();
      $scope.changeTooltip();
      $scope.centerMap();
    });

    /**
     * inform leaflet that te dimensions of the map changed
     * this leads to recalculating, which tiles have to be shown etc.
     */
    var fullscreenWatcher = $scope.$watch('config.fullscreen', function () {
      $scope.map.invalidateSize();
      $scope.changeTooltip();
      $scope.centerMap();
    });

    jQuery(document).on("fullscreen", function (e) {
      $scope.map.invalidateSize();
      $scope.changeTooltip();
      $scope.centerMap();
    });

    /**
     * @param {DataLayer} datalayer
     */
    $scope.setDataLayerData = function (datalayer) {
      if (!datalayer || angular.equals({}, datalayer)) {
        console.warn("Can't load DataLayerData without DataLayer");
        return;
      }
      $scope.config.dataLayerToShow = datalayer.year;
      $scope.dataLayerToShow = datalayer;
      $scope.numberOfDataLayers = Object.keys($scope.layers).length;
      clearMap();

      $scope.geojson = L.geoJson(JSON.parse($scope.dataLayerToShow.geo_json), {
        onEachFeature: onEachFeature
      }).addTo($scope.map);

      if (groupDistricts.length) {
        featureGroups = {};
        $scope.geojson.eachLayer(function (layer) {
          var districtKey = layer.feature.properties.key,
            blKey = '';
          if (districtKey && districtKey.length == 8 || districtKey.length == 5) {
            blKey = districtKey.substring(0, 2);
          } else if (districtKey) {
            blKey = '0' + districtKey.substring(0, 1);
          } else {
            return;
          }

          if (mapConfig.keyLandMapping.keys[blKey]) {
            var groupKey = mapConfig.keyLandMapping.keys[blKey].key;
            if (!featureGroups[groupKey]) {
              featureGroups[groupKey] = L.featureGroup();
            }
            layer.addTo(featureGroups[groupKey]);
          }
        });
      }

      if ($scope.indicatorToShow == null && angular.isArray($scope.selectedIndicators)) {
        var indicatorToShowPosition = $scope.selectedIndicators.map(function (d) {
          return d.key;
        }).indexOf($scope.config.indicatorToShow);
        $scope.indicatorToShow = $scope.selectedIndicators[indicatorToShowPosition];
      }

      if ($scope.indicatorToShow) {
        if ($scope.selectedDataLayer.legend && $scope.selectedDataLayer.legend[$scope.indicatorToShow.uid] != null && $scope.selectedDataLayer.legend[$scope.indicatorToShow.uid].map != null) {
          $scope.config.selectedColorSet = $scope.selectedDataLayer.legend[$scope.indicatorToShow.uid].map.colorSet;
        } else if ($scope.indicatorToShow.defaultColorSet) {
          $scope.config.selectedColorSet = $scope.indicatorToShow.defaultColorSet;
        }

        $scope.indicatorToShow.updateScales($scope.selectedDataLayer, $scope.indicatorToShow, $scope.selectedColorSet, $scope.config.selectedClassMethod, $scope.config.numberOfScales);
      }

      $scope.colorDistrictsBasedOnIndicatorScale();
      $scope.changeTooltip();
      $scope.centerMap();
    };

    /**
     * fit map-view to bounds
     */
    $scope.centerMap = function () {
      if ($scope.geojson && !$scope.blToZoom) {
        $scope.map.fitBounds($scope.geojson.getBounds());
      } else if (!$scope.geojson) {
        console.warn("No geoJSON found");
      }
    };

    /**
     * Binds mouse-events and labels to each feature
     * @param feature
     * @param layer
     */
    function onEachFeature(feature, layer) {
      // overwrite Feature Properties from district
      if (!$scope.layers[$scope.config.dataLayerToShow]) return;
      var district = $scope.layers[$scope.config.dataLayerToShow].districts[feature.properties.id];
      if (district) {
        feature.properties.key = district.key;
        feature.properties.name = district.name;
        feature.properties.uid = district.uid;
      }
      layer.on({
        mouseover: highlightFeature,
        mouseout: resetHighlight,
        click: selectDistrictAndZoomToFeature
      });
      layer.bindTooltip($scope.getTooltipFromFeature(feature), {permanent: true, direction: getLabelAlignment()});
    }

    function getLabelAlignment() {
      return $scope.config.labelAlignment === 'no-background' ? 'center' : $scope.config.labelAlignment;
    }

    /**
     * apply hover style
     *
     * @param {Event} e the mouseover event
     */
    function highlightFeature(e) {
      var key = e.target.feature.properties.key;
      if (mouseOverFeatureKey === key) return;
      mouseOverFeatureKey = key;
      var layer = e.target;
      var selected = isLayerSelected(layer);
      var roundedValue = null;
      if (layer.feature.properties.value != null) {
        roundedValue = +layer.feature.properties.value.toFixed(getDecimals());
      }

      var style = DistrictStyling.getStyleForIndicatorAndValue($scope.indicatorToShow, roundedValue, $scope.config.districtOpacity, selected, true);

      if (!$scope.blToZoom) layer.setStyle(style);

      info.update(layer.feature.properties, $scope.indicatorToShow);
      if (layer.bringToFront) {
        layer.bringToFront();
      }
    }

    /**
     * reset the hover style
     *
     * @param {Event} e the mouseout event
     */
    function resetHighlight(e) {
      mouseOverFeatureKey = '';
      var layer = e.target;
      var selected = isLayerSelected(layer);

      var roundedValue = null;
      if (layer.feature.properties.value != null) {
        roundedValue = +layer.feature.properties.value.toFixed(getDecimals());
      }
      var style = DistrictStyling.getStyleForIndicatorAndValue($scope.indicatorToShow, roundedValue, $scope.config.districtOpacity, selected, false)
      if (!$scope.blToZoom) layer.setStyle(style);
      info.update();
      if (!selected && !L.Browser.ie && !L.Browser.opera && !L.Browser.edge) {
        layer.bringToBack();
      }
    }

    /**
     * get decimals from legend or default map-config
     * @returns {number|*}
     */
    function getDecimals() {
      var legend = $scope.selectedDataLayer && $scope.indicatorToShow && $scope.selectedDataLayer.legend && $scope.selectedDataLayer.legend[$scope.indicatorToShow.uid] ? $scope.selectedDataLayer.legend[$scope.indicatorToShow.uid]['map'] : null;
      if (legend && legend.hasOwnProperty('decimals') && legend.decimals !== null) {
        return legend.decimals;
      } else {
        return $scope.indicatorToShow.unit === '%' ? mapConfig.relativeIndicatorsDecimalPlaces : mapConfig.absoluteIndicatorsDecimalPlaces;
      }
    }

    /**
     * @param {Event} e
     */
    function selectDistrictAndZoomToFeature(e) {
      var key = e.target.feature.properties.key;
      if (districtSingleSelection) resetHighlight(e);
      if (districtSingleSelection !== key) {
        highlightFeature(e);
        districtSingleSelection = key;
        $scope.singleSelectDistrict({district: key});
      }
    }

    /**
     * Based on the selected indicator and data layer we
     * color the districts based on their indicator scale
     */
    $scope.colorDistrictsBasedOnIndicatorScale = function () {
      if (!$scope.geojson) return;
      var dataLayer = $scope.dataLayerToShow;
      var indicator = $scope.indicatorToShow;
      var selectedKeys = $scope.selectedDistricts.map(function (district) {
        return district.key;
      });

      $scope.geojson.eachLayer(function (layer) {
        var uid = layer.feature.properties.id;
        var value = null;
        if (indicator) {
          value = DataLayerService.getValueForDistrictAndIndicator(dataLayer, uid, indicator.uid);
        }

        var selected = selectedKeys.indexOf(layer.feature.properties.key) !== -1;
        var roundedValue = null;
        if (value != null) {
          roundedValue = +value.toFixed(getDecimals());
        }

        var style = DistrictStyling.getStyleForIndicatorAndValue(indicator, roundedValue, $scope.config.districtOpacity, selected, false);

        layer.setStyle(style);
        layer.feature.properties.value = roundedValue;
        if (indicator) {
          layer.feature.properties.unit = indicator.unit;
          layer.feature.properties.prefix = indicator.prefix;
          layer.feature.properties.description = dataLayer.descriptions[uid][indicator.uid];
          layer.feature.properties.indicator = indicator;
        }

        if (selected && !L.Browser.ie && !L.Browser.opera && !L.Browser.edge) {
          layer.bringToFront();
        }
      });

      if ($scope.blToZoom) {
        zoomToBl($scope.blToZoom);
      }
    };

    /**
     * Based on the selected indicator and data layer we
     * color the districts based on their indicator scale
     */
    function clearFeatures() {
      if (!$scope.geojson) {
        return;
      }
      $scope.geojson.eachLayer(function (layer) {
        var selected = isLayerSelected(layer);
        layer.setStyle(DistrictStyling.getStyleForIndicatorAndValue(null, null, $scope.config.districtOpacity, selected, false));
        layer.feature.properties.value = undefined;
      });
    }

    /**
     * Creates Tooltip from feature-properties
     * @param feature
     * @returns {string}
     */
    $scope.getTooltipFromFeature = function (feature) {
      return getToolTipTemplate(feature.properties.key, feature.properties.name, feature.properties.value, feature.properties.unit);
    };

    /**
     * Selects explicit Indicator for this Map-Widget
     */
    $scope.selectMapIndicator = function () {
      if (!$scope.config.indicatorToShow) return;
      $scope.config.indicatorToShow.scales = UtilityService.buildIndicatorScales($scope.selectedDataLayer, $scope.config.indicatorToShow, $scope.selectedColorSet, $scope.config.selectedClassMethod, $scope.config.numberOfScales, $scope.config.indicatorToShow.inverted);
      $scope.colorDistrictsBasedOnIndicatorScale();
      $scope.changeTooltip();
    };

    /**
     * Changes Shape-Tooltip
     */
    $scope.changeTooltip = function () {
      if (!$scope.geojson) return;
      var indicator = $scope.indicatorToShow,
        dataLayer = $scope.dataLayerToShow;

      $scope.geojson.eachLayer(function (layer) {
        var uid = layer.feature.properties.id;
        var value = null;
        if (indicator) {
          value = DataLayerService.getValueForDistrictAndIndicator(dataLayer, uid, indicator.uid);
        }

        var label = getToolTipTemplate(layer.feature.properties.key, layer.feature.properties.name, value, indicator ? indicator.unit : '');
        layer.getTooltip().options.direction = getLabelAlignment();
        layer.setTooltipContent(label);
        jQuery('.chart-column').on('mouseover', function () {
          var properties = {};
          properties.key = jQuery(this).data('key');
          properties.name = jQuery(this).data('district');
          properties.value = jQuery(this).data('value');
          properties.unit = jQuery(this).data('unit');
          info.update(properties);
        });
      });
    };

    /**
     * deletes all geo-layers
     */
    function clearMap() {
      if (!$scope.geojson) return;
      $scope.geojson.eachLayer(function (layer) {
        $scope.map.removeLayer(layer);
      });
    }

    var blToZoomWatcher = $scope.$watch('blToZoom', function (blKey) {
      if (!featureGroups) return;
      zoomToBl(blKey);
    });

    function zoomToBl(blKey) {
      angular.forEach(featureGroups, function (features, key) {
        if (blKey == key) {
          features.setStyle({
            fillOpacity: $scope.config.districtOpacity
          });
        } else if (!blKey) {
          features.setStyle({
            fillOpacity: $scope.config.districtOpacity
          });
        } else {
          features.setStyle({
            fillOpacity: 0.05
          });
        }
      });
      if (blKey) {
        $scope.map.fitBounds(featureGroups[blKey].getBounds());
      } else {
        $scope.map.fitBounds($scope.geojson.getBounds());
      }
    }

    /**
     * initialize Leaflet-Map
     * Adds tile-layer-control
     */
    function initializeMap() {
      jQuery($element).find('.map').height(jQuery($element).closest('.grid-stack-item-content-map').height() - 10);
      $scope.mapContainer = $element[0].querySelectorAll('.map')[0];
      $scope.map = L.map(
        $scope.mapContainer
      );

      // disable mouseScroll
      $scope.map.scrollWheelZoom.disable();

      info = L.control({position: 'topleft'});

      info.onAdd = function () {
        districtInfo = L.DomUtil.create('div', 'district-info');
        this.update();
        return districtInfo;
      };

      info.update = function (properties, indicatorToShow) {
        var legend = false;
        if (properties) {
          var content = '<div class="district-info-content"><b>' + properties.name + '</b><br />';
          if (properties.key) {
            content += '<span class="info-district-key">Schlüssel: ' + properties.key + '<br/></span>';
          }

          // legend
          if ($scope.indicatorToShow && $scope.selectedDataLayer.legend[$scope.indicatorToShow.uid] && $scope.selectedDataLayer.legend[$scope.indicatorToShow.uid]['map']) {
            legend = $scope.selectedDataLayer.legend[$scope.indicatorToShow.uid]['map'];
          }

          // show all indicatortype values in hover
          if (mapConfig.showIndicatorTypeInMapHover && indicatorToShow != null && indicatorToShow.isDefault) {
            var setToShow = $scope.indicatorSets.filter(function (set) {
              return set.uid === indicatorToShow.type;
            })[0];

            if (angular.isArray(setToShow.indicators)) {
              content += '<span class="info-indicator-type">';
              content += setToShow.indicators.sort(function (a, b) {
                return a.listIndex - b.listIndex;
              }).map(function (indicator) {
                var value = $scope.selectedDataLayer[properties.id][indicator.uid];
                if (value == null) {
                  var description = $scope.selectedDataLayer['descriptions'][properties.id][indicator.uid] ? $scope.selectedDataLayer['descriptions'][properties.id][indicator.uid] : null;
                  return description ? indicator.name + ': ' + description : null;
                }
                var roundedValue;

                if (indicator.categorical && legend) {

                  // show label from legend instead of value for categorical indicators
                  roundedValue = legend.scales.reduce(function (accu, scale) {
                    return (value >= scale.from && value < scale.to) ? scale.text : accu;
                  }, '');
                } else if (indicator.unit === '%') {
                  //roundedValue = (legend && legend.decimals && legend.decimals !== 0 ? germanNumberFormat(',.' + legend.decimals + 'f')(value) : numberFormatRelative(value)) + '%';
                  roundedValue = germanNumberFormat(value) + '%';
                } else {
                  roundedValue = germanNumberFormat(value);
                }
                return indicator.name + ': ' + indicator.prefix + roundedValue;
              }).filter(function (value) {
                return value != null;
              }).join('<br/>');
              content += '</span>';
            }
          } else if (properties.value !== null) {
            // show only main value
            var roundedValue;
            if (properties.indicator && properties.indicator.categorical && legend) {
              // show label from legend instead of value for categorical indicators
              roundedValue = legend.scales.reduce(function (accu, scale) {
                return properties.value >= scale.from && properties.value < scale.to ? scale.text : accu;
              }, '');
            } else if (properties.unit === '%') {
              roundedValue = germanNumberFormat(properties.value) + '%';
            } else {
              roundedValue = germanNumberFormat(properties.value);
            }
            content += $scope.indicatorToShow.name + ': ' + properties.prefix + roundedValue;
          } else if (properties.description) {
            content += $scope.indicatorToShow.name + ': ' + properties.description.replace(/<(?:.|\n)*?>/gm, ''); // strip html-tags with jQuery-Function text()
          }
          content += '</div>';
          districtInfo.innerHTML = content;
        } else {
          districtInfo.innerHTML = '';
        }
      };

      info.addTo($scope.map);
    }

    /**
     * Returns Tooltip-HTML-String
     * @param {string} key
     * @param {string} name
     * @param {string} value
     * @param {string} unit
     * @returns {string}
     */
    function getToolTipTemplate(key, name, value, unit) {
      if (value != null) {
        if (unit) {
          value = numberFormat(value);
        }
        value += unit;
      } else {
        value = '';
      }

      var keyHTML = $scope.config.optionStates.showId ? '<div><b>' + key + '</b></div>' : '';
      var nameHTML = $scope.config.optionStates.showTitle ? '<div>' + name + '</div>' : '';
      var valueHTML = value && $scope.config.optionStates.showValue && $scope.config.indicatorToShow ? '<div>' + value + '</div>' : '';

      var content = keyHTML + nameHTML + valueHTML;

      return content ? '<div class="tooltip-content">' + keyHTML + nameHTML + valueHTML + '</div>' : ' ';
    }

    /**
     * checks if a given layer is currently selected
     *
     * @param {Object} layer the layer to check
     * @returns {boolean}
     */
    function isLayerSelected(layer) {
      var selectedKeys = $scope.selectedDistricts.map(function (district) {
        return district.key;
      });

      return selectedKeys.indexOf(layer.feature.properties.key) !== -1;
    }

    initializeMap();

    // cleanup watcher on destroy-event of the element
    // this is called when the gridelement is removed
    $element.on('$destroy', function () {
      dimensionWatcher();
      indicatorToShowWatcher();
      selectedIndicatorsWatcher();
      selectedColorSetWatcher();
      colorSetsWatcher();
      selectedDataLayerWatcher();
      invertedWatcher();
      selectedDistrictsWatcher();
      selectedAlignmentWatcher();
      fullscreenWatcher();
      blToZoomWatcher();
    });
  }
);
